/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LedgerPaymentAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import InsurancePaymentAccount from './InsurancePaymentAccount/index'
import No from './No/index'
import PersonPaymentAccount from './PersonPaymentAccount/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LedgerPaymentAccount({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'payment_account',
path: 'account_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentAccountAccountTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PersonPaymentAccount'}>
<PersonPaymentAccount
  viewPath={`${viewPath}/PersonPaymentAccount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InsurancePaymentAccount'}>
<InsurancePaymentAccount
  viewPath={`${viewPath}/InsurancePaymentAccount`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}